<dx-popup
    #reverseEditorBox
    width="30%"
    height="40%"
    title="Confirmation"
    [showTitle]="true"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onHidden)="onHidden($event)"
>
    <div *dxTemplate="let item of 'content'" class="ar-payment-reverse-editor-content">
        <dx-box width="100%" height="100%" direction="col" *ngIf="!!reversePaymentEditorData">
            <dxi-item [ratio]="1">
                <span>Are you sure you want to reverse the payment? Please supply a reason</span>
                <dx-form
                    #confirmForm
                    width="100%"
                    height="100%"
                    [colCount]="1"
                    validationGroup="arPaymentReverseEditor"
                    [showValidationSummary]="true"
                    [labelLocation]="defaultLabelLocation"
                    [(formData)]="paymentInfo"
                >
                    <dxi-item itemType="empty"></dxi-item>
                    <dxi-item isRequired="true">
                        <dxo-label text="Reversal Description"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-area [height]="70" [maxLength]="170" [(value)]="paymentInfo.reversalDescription">
                                <dxi-validation-rule
                                    type="required"
                                    message="Reversal Description is required"
                                ></dxi-validation-rule>
                                <dxi-validation-rule
                                    type="stringLength"
                                    min="10"
                                    message="Reversal Description must have at least 10 characters"
                                ></dxi-validation-rule>
                            </dx-text-area>
                        </div>
                    </dxi-item>
                    <dxi-item isRequired="true">
                        <dxo-label text="Reversal Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box
                                [width]="100"
                                [min]="reversePaymentEditorData?.minReverseDate"
                                [(value)]="paymentInfo.reverseDate"
                                type="date"
                            ></dx-date-box>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>

            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Cancel"
                                [icon]="closeIcon"
                                (onClick)="onHidden($event)"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                text="Yes"
                                [icon]="saveIcon"
                                [disabled]="disableReverseButton"
                                (onClick)="onYesClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel *ngIf="loadingVisible" [position]="body" [visible]="true"></dx-load-panel>

<app-ar-misc-invoice-editor
    *ngIf="showMiscInvoiceEditor"
    [visible]="showMiscInvoiceEditor"
    [managementCompanyId]="arPaymentParam?.managementCompanyId"
    [communityId]="arPaymentParam?.communityId"
    [customerId]="arPaymentDetail?.customerCode"
    [customerName]="arPaymentDetail?.customerName"
    [nsfChargeText]="'NSF Fee'"
    (closeMiscEditor)="closeMiscInvoiceEditor()"
></app-ar-misc-invoice-editor>
